export default dam => ({
  computed: {
    canAll() {
      return this.permissions.includes(`${dam}.all`);
    },
    canChangeSensorsLimits() {
      if (this.canAll) {
        return true;
      }
      return this.permissions.includes(`${dam}.change_sensors_limits`);
    },
    canChangeSensorsFormulas() {
      if (this.canAll) {
        return true;
      }
      return this.permissions.includes(`${dam}.change_sensors_formulas`);
    }
  }
});
